const CDN = process.env.REACT_APP_RESIZABLE;

const UserAvatar = ({userData, isAvatarActive, avatarClass}) => {
    if (userData === undefined) {
        return (
            <span
                className={`sl-avatar ${avatarClass} ${isAvatarActive ? 'sl-avatar-active' : ''}`}
                data-letters='??'
            />
        );
    }

    return (
        userData?.avatar === null ? (
            <span
                className={`sl-avatar sl-border-1 sl-border-gray-300 sl-border-solid ${avatarClass} ${isAvatarActive ? 'sl-avatar-active' : ''}`}
                data-letters={`${userData.first_name.charAt(0)?.toUpperCase()}${userData.last_name.charAt(0)?.toUpperCase()}`}
            />
        ) : (
            <img
                className={`sl-avatar ${avatarClass} ${isAvatarActive ? 'sl-avatar-active' : ''}`}
                src={`${CDN}/${userData.avatar}`}
                alt="User Avatar"
            />
        )
    );
};

export default UserAvatar;
